module.exports = __webpack_public_path__ + "static/img/case_3.68d8581d.jpg";